import {Place} from './place';

export class Scheduler {
  id: string;
  schedule: Place[]

  constructor(id: string, schedule: Place[]) {
    this.id = id;
    this.schedule = schedule;
  }
}
